// src/services/fmdService.js

import instance from "../../axios";


export const fetchFleetSize = async (signal) => {
    const response = await instance.get("/api/dashboards/fmd/3",{signal});
    const data = response || {};

    const dt = Object.entries(data).map(([key, value]) => {
        let modifiedKey = key === "car" ? "Sedan" : key === "suv" ? key.toUpperCase() : key;
        return { name: modifiedKey, value };
    });

    const COLORS = [
        "#003F5C",
        "#29AF5C",
        "#009E6F",
        "#008C7D",
        "#1E72B8",
        "#6D71C5",
        "#007981",
        "#00667D",
        "#005270",
        "#6FBD43",
    ];

    return dt.map((item, index) => ({
        ...item,
        color: COLORS[index % COLORS.length],
    }));
};

export const fetchMaintenanceCosts = async (signal) => {
    const response = await instance.get("/api/dashboards/fmd/14",{signal});
    const data = response || {};
    return {
        costPerDay: data.costPerDay || {},
        costPerKm: data.costPerKm || {},
    };
};

export const fetchUsedServices = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/8?to=${to}&from=${from}`
        : `/api/dashboards/fmd/8`;

    const response = await instance.get(url,{signal});
    const data = response || [];

    const maxUsedCount = Math.max(...data.map((item) => item.usedCount || 0)) || 1;

    return data.map((item) => ({
        ...item,
        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
    }));
};
export const fetchUsedParts = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/7?to=${to}&from=${from}`
        : `/api/dashboards/fmd/7`;

    const response = await instance.get(url,{signal});
    const data = response || [];

    const maxUsedCount = Math.max(...data.map((item) => item.usedCount || 0)) || 1;

    return data.map((item) => ({
        ...item,
        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
    }));
};

export const fetchUsedPackages = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/6?to=${to}&from=${from}`
        : `/api/dashboards/fmd/6`;

    const response = await instance.get(url,{signal});
    const data = response || [];

    const maxUsedCount = Math.max(...data.map((item) => item.usedCount || 0)) || 1;

    return data.map((item) => ({
        ...item,
        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
    }));
};

export const fetchMaintenaceRequest = async (to, from, setStateCallback,signal) => {
  let url = to && from
    ? `/api/dashboards/fmd/5?to=${to}&from=${from}`
    : `/api/dashboards/fmd/5`;

  try {
     const res = await instance.get(url, { signal });
    let dt = [];
    for (const [key, value] of Object.entries(res)) {
      dt.push({ name: key, value });
    }

    const maxUsedCount = Math.max(...dt.map((item) => item.value));

    const usedPartPercentages = dt.map((item) => ({
      ...item,
      countPercentage: (item.value / maxUsedCount) * 100,
    }));

    const findItem = usedPartPercentages.find((item) => item.name === "items");
    const findService = usedPartPercentages.find((item) => item.name === "services");
    const findPackages = usedPartPercentages.find((item) => item.name === "packages");

    // update state
    setStateCallback({
      maintRequestCategory: res,
      partsMaintRequest: findItem,
      serviceMaintRequest: findService,
      packageMaintRequest: findPackages,
    });

  } catch (err) {
    console.error("err 5====", err);
  }
};

export const fetchTotalInvoices = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/1?to=${to}&from=${from}`
        : `/api/dashboards/fmd/1`;

    const response = await instance.get(url,{signal});
    const data = response||"";
    return data
};
export const fetchTotalMaintenanceRequest = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/4?to=${to}&from=${from}`
        : `/api/dashboards/fmd/4`;

    const response = await instance.get(url,{signal});
    const data = response||"";
    return data
};

export const fetchCostbyVehicleClassification = async (to, from,signal) => {
    const url = to && from
        ? `/api/dashboards/fmd/9?to=${to}&from=${from}`
        : `/api/dashboards/fmd/9`;

    const response = await instance.get(url,{signal});
    const data = response||{};
    return data
};

export const fetchTop20HighestMaintCost= async (signal) => {
    const response = await instance.get("/api/dashboards/fmd/12",{signal});
    const data = response || [];

    return data;
};

export const fetchCarbonFootPrint= async (signal) => {
    const response = await instance.get("/api/dashboards/fmd/11",{signal});
    const data = response || [];
         const newobj = {
            totalCarbonFootPrint: data && data.totalCarbonFootPrint,
            categoryWiseCarbonFootPrint: Object.entries(
              data?.categoryWiseCarbonFootPrint
            )
              // .filter(([name, value]) => value !== 0)
              .map(([name, value]) => ({ name, value }))
              .sort((a, b) => b.value - a.value),
          };

    return newobj;
};